import { AxiosPromise } from 'axios';
import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { ConsumerLoanOverview } from '../models/ConsumerLoanOverview';

export const getConsumerLoanOverview = (personId: number, applicationId: number): AxiosPromise<ConsumerLoanOverview> =>
    AxiosClientFactory
        .getInstance()
        .get<ConsumerLoanOverview>(`/api/applicants/${personId}/consumerLoans/${applicationId}/overview`);
